// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobile-page[data-v-3af8c57e]  video{width:100% !important}.box[data-v-3af8c57e]{min-height:100px;padding:10px;background:#f5f5f5}.box[data-v-3af8c57e]  img{max-width:100%;height:auto}", ""]);
// Exports
module.exports = exports;
